import { useCallback } from "react";

import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestMutation from "@/remoteState/useRestMutation";

const useUnhideContent = () => {
  const unHideContent = useCallback((hideId) => {
    const requestParams = {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
    };
    return new Request(
      `${MONOLITH_ORIGIN}/api/v3/content-hide/${hideId}/`,
      requestParams,
    );
  }, []);
  return useRestMutation(unHideContent);
};

export default useUnhideContent;
